import React, { useState } from "react";
import uploadIcon from "../../assets/images/upload.png";
import "bootstrap/dist/css/bootstrap.min.css";
import { toast } from "react-toastify";
import { uploadBanner } from "../../api/uploadMedia";
import CopyUploadedUrl from "./CopyUploadedUrl";

const UploadBanner = ({referesh}) => {
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("");
  const [uplodedFileName, setUplodedFileName] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [dialogShow, setDialogShow] = useState(false);
  const [uploadedUrl, setUploadedUrl] = useState("");

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    resetFileState();

    if (selectedFile) {
      if (selectedFile.size > 83886080) {
        setError("File size must be less than 80 MB.");
      } else {
        setError("");
        setFile(selectedFile);
        const timestamp = Date.now();
        const fileExtension = selectedFile.name.split(".").pop();
        const newFileName = `banner_${timestamp}.${fileExtension}`;
        setFileName(newFileName);
        setUplodedFileName(newFileName)
      }
    }
  };

  const resetFileState = () => {
    setFile(null);
    setFileName("");
    setError("");
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!file) {
      alert("Please select a valid file to upload.");
      return;
    }

    try {
      setLoading(true);
      const finalFileName = fileName;
      const renamedFile = new File([file], finalFileName, { type: file.type });
      const response = await uploadBanner(renamedFile, finalFileName);

      if (response.status === 201) {
        resetFileState();
        setUploadedUrl(response.data.url);
        setDialogShow(true);
        toast.success("Your banner was uploaded successfully!", {
          position: "top-center",
          autoClose: 5000,
        });
        referesh()
      } else {
        setError("Something went wrong! Please try again later");
      }
    } catch (error) {
      console.error(
        "Error:",
        error.response ? error.response.data : error.message
      );
      setError("There was an error uploading the banner.");
    } finally {
      setLoading(false);
    }
  };

  const handleCloseDialog = () => {
    setDialogShow(false);
    setUplodedFileName("")
  };

  return (
    <div className="container d-flex flex-column">
      <div className="card shadow-sm rounded">
        <div
          className="card-header text-center text-white py-3"
          style={{ backgroundColor: "#1E70C8" }}
        >
          <h5 className="mb-0">Upload Your Banner</h5>
          <p className="mb-0 small">Select a banner for your exercise</p>
        </div>
        <div className="card-body">
          <div className="text-center mb-3 justify-content-center d-flex">
            <button
              type="button"
              className="btn btn-outline-secondary d-flex justify-content-center align-items-center"
              onClick={() => document.getElementById("bannerFileInput").click()}
              style={{
                width: "70px",
                height: "70px",
                borderRadius: "50%",
                border: "2px dashed #ccc",
              }}
            >
              <img
                src={uploadIcon}
                alt="Upload"
                style={{ width: "40px", height: "40px" }}
              />
            </button>
          </div>
          <form onSubmit={handleSubmit} className="text-center">
            <input
              type="file"
              accept="image/*"
              onChange={handleFileChange}
              required
              className="d-none"
              id="bannerFileInput"
            />
            <div className="form-group mb-3">
              <input
                type="text"
                placeholder="Selected Banner"
                value={fileName}
                readOnly ={file ? false : true}
                onChange={(e) => { setFileName(e.target.value); setUplodedFileName(e.target.value)} }
                className="form-control text-center"
                style={{ backgroundColor: "#f8f9fa" }}
              />
            </div>
          
            {error && (
              <div className="alert alert-danger" role="alert">
                {error}
              </div>
            )}
            <button
              type="submit"
              className="btn btn-primary w-100"
              disabled={!file || loading}
              style={{ backgroundColor: "#1E70C8" }}
            >
              {loading ? (
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
              ) : (
                "Upload Banner"
              )}
            </button>
          </form>
        </div>
      </div>
      <CopyUploadedUrl
        show={dialogShow}
        handleClose={handleCloseDialog}
        url={uploadedUrl}
        fileName={uplodedFileName}
      />
    </div>
  );
};

export default UploadBanner;